
// Das geht nicht... hyperform ist scheisse gebaut ... :D
// import hyperform from 'hyperform/src/hyperform';
const hyperformModule = require('hyperform');
const hyperform = hyperformModule.default;

hyperform(window, {
    classes: {
        warning: 'form__error', // hf-warning
        valid: 'hf-valid',
        invalid: 'hf-invalid',
        validated: 'hf-validated'
    }
});


import hyperformTranslations from './global-forms/translations';

hyperformTranslations(hyperform);


const customAttachWarningFn = function(warning, element) {
    // remove any errors from server side validation
    element.classList.remove('error');
    if (element.nextElementSibling && element.nextElementSibling.classList.contains('error') && element.nextElementSibling.classList.contains('help-block')) {
        element.nextElementSibling.remove();
    }

    const formGroup = element.closest('.form-group');
    formGroup.classList.add('has-error');

    formGroup.appendChild(warning);

    // Workaround für Radio-Buttons.
    // Da wurde detachWarning nur aufgerufen, wenn
    if (element.type === 'radio') {
        const radioButtons = formGroup.querySelectorAll('input[name="' + element.name + '"]');
        const radioRemoveFn = () => {
            for (let i = 1, len = radioButtons.length; i < len; i++) {
                radioButtons[i].removeEventListener('change', radioRemoveFn, false);
            }

            customDetachWarningFn(warning, element);
        };
        for (let i = 1, len = radioButtons.length; i < len; i++) {
            radioButtons[i].addEventListener('change', radioRemoveFn, false);
        }
    }
};

const customDetachWarningFn = function(warning, element) {
    const formGroup = element.closest('.form-group');
    formGroup.classList.remove('has-error');

    // remove any errors from server side validation
    element.classList.remove('error');
    if (element.nextElementSibling && element.nextElementSibling.classList.contains('error') && element.nextElementSibling.classList.contains('help-block')) {
        element.nextElementSibling.remove();
    }

    warning.remove();
};

/* @param warning HTMLElement the element containing the error message
 * @param element HTMLElement the form element, i.e., the <input>, that is
 *                            invalid
 */
hyperform.setRenderer('attachWarning', customAttachWarningFn);
/* @param warning HTMLElement the element containing the error message
 * @param element HTMLElement the form element, i.e., the <input>, that is
 *                            invalid
 */
hyperform.setRenderer('detachWarning', customDetachWarningFn);



document.querySelectorAll('form .form-group input, form .form-group select, form .form-group textarea').forEach(element => {
    // Leck mich doch am Arsch...... -_-
    // Entfernt die Serve Side Fehler, wenn man eine Eingabe ändert.
    // Wird aber nur einmal ausgeführt um nur einmal den Fehler zu löschen
    const eventListener = () => {
        element.classList.remove('error');
        if (element.nextElementSibling && element.nextElementSibling.classList.contains('error') && element.nextElementSibling.classList.contains('help-block')) {
            element.nextElementSibling.remove();
        }
        element.closest('.form-group').classList.remove('has-error');

        element.removeEventListener('click', eventListener);
    };
    element.addEventListener('change', eventListener);

    // Scrollt richtig zum ersten Fehlerhaften Element im jeweiligen Formular.
    element.addEventListener('invalid', () => {
        const firstInvalidElement = element.closest('form').querySelector('.hf-invalid');

        if (firstInvalidElement !== null) {
            let scrollTarget = firstInvalidElement.closest('form > .form-group');
            if (scrollTarget === null) {
                scrollTarget = firstInvalidElement;
            }

            scrollTarget.scrollIntoView();
        }
    });
});

/* Formular mit Textarea userData bekommt class="withUserData"
    class wird in Hook PfleidererForm hinzugefügt wenn defaultValue API:userdata ist
 */
if (document.getElementsByClassName('userData').length) {
    const userText = document.getElementsByClassName('userData')[0];
    userText.form.classList.add('withUserData');
    userText.disabled = true;
    userText.rows = 6;
}

/* Formular: Lokalisietung von defaultValues in input und textarea;
   benötigt in form.yaml
       properties:
          fluidAdditionalAttributes:
            required: required
            data-localisedvalue: ''
 */
document.querySelectorAll('input, textarea').forEach(element => {
    if(element.dataset.localisedvalue) {
        element.value = element.dataset.localisedvalue;
    }
});

// Prevent Multiple sends for one form
document.querySelectorAll('.context--modal form').forEach(form => {
    form.addEventListener('submit', (event) => {
        if (form.classList.contains('form--submitted')) {
            event.preventDefault();
            return false;
        }
        form.classList.add('form--submitted');
    });
});


